import { NgModule } from '@angular/core';
import {DropdownDirective} from './components/dropdown-directive/dropdown.directive';
import {DropdownToggleDirective} from './components/dropdown-directive/dropdown-toggle.directive';
import {DropdownContentDirective} from './components/dropdown-directive/dropdown-content.directive';

@NgModule({
  declarations: [
      DropdownDirective,
      DropdownToggleDirective,
      DropdownContentDirective,
  ],
  imports: [
  ],
  exports: [
      DropdownDirective,
      DropdownToggleDirective,
      DropdownContentDirective,
  ]
})
export class Lab365CommonModule { }
